import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import StatCounter from '../components/StatCounter';
import ChartComboFinance from '../charts/ChartComboFinance';
import { FINANCE_KPIS, FINANCING_PLAN } from '../data/mockData';

// 区块7：财务预测
export default function Section07Finance() {
  return (
    <SectionWrapper
      id="finance"
      title="财务预测"
      subtitle="基于回归预测模型与数理统计建模，本项目预计于第18个月实现盈亏平衡，五年累计营收达2950万元。"
    >
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* 主视觉：组合图 */}
        <ScrollReveal className="lg:col-span-3">
          <div className="glass-card min-h-[520px]">
            <ChartComboFinance />
          </div>
        </ScrollReveal>

        {/* 右侧：融资计划表 */}
        <ScrollReveal delay={150} className="lg:col-span-1">
          <div className="glass-card h-full">
            <h3 className="text-2xl font-bold text-gold mb-6">融资计划</h3>
            <div className="space-y-4">
              {FINANCING_PLAN.map((plan, index) => (
                <div
                  key={index}
                  className="p-4 rounded-xl bg-white/5 border-l-4 border-l-cyan"
                >
                  <div className="text-lg font-bold text-white">{plan.round}</div>
                  <div className="text-xl font-black text-gold my-1">{plan.amount}</div>
                  <div className="text-sm text-slate-300">{plan.usage}</div>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>

      {/* 下方：3个KPI卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        {FINANCE_KPIS.map((kpi, index) => (
          <ScrollReveal key={index} delay={100 * index}>
            <div className="glass-card text-center">
              <div className="stat-number text-5xl mb-2">
                <StatCounter value={kpi.value} suffix={kpi.suffix} />
              </div>
              <div className="text-xl font-bold text-white">{kpi.label}</div>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </SectionWrapper>
  );
}
